import React from 'react';

export const CraftAndCodeLogo: React.FC = () => (
  <div style={{ height: '70px', display: 'flex', alignItems: 'center' }}>
    <img
      src="/images/logos/craftandcode-logo.png"
      alt="Craft &amp; Code"
      width={300}
      height={70}
      className="dark:hidden"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
    />
    <img
      src="/images/logos/craftandcode-logo-dark.png"
      alt="Craft &amp; Code"
      width={300}
      height={70}
      className="hidden dark:block"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
    />
  </div>
);
